// @flow

// Organizations
export const ORGA_WRITE = 'organizations:org:write';

// Customers
export const RESELLEE_WRITE = 'organizations:resellee:write';
